import type { Mouvement } from '@mairistem/comptabilite';
import type React from 'react';
import ArticleNonBudgetaireComponent from '../../../components/Mouvement/Panel/ArticleNonBudgetaireComponent';
import CODE_PANEL from '../../../constants/mouvements/codePanel';
import type PanelComponentProps from '../../../interfaces/pieces/mouvements/panelComponentProps';
import LignePanel from './LignePanel';

class ArticleNonBudgetairePanel extends LignePanel {
	constructor(isMandatory = false) {
		super(isMandatory);
		this.code = CODE_PANEL.ARTICLE_NON_BUDGETAIRE;
		this.icon = { name: 'newspaper outline' };
	}

	getLibelle = () => 'Imputation OPO';

	isEmpty = (data: Mouvement) =>
		!data?.lignes?.find((ligne) => ligne?.codeArticleNonBudgetaire);

	getComponent = function getComponent(
		data: PanelComponentProps['data'],
		onChange: PanelComponentProps['onChange'],
		handlePin: PanelComponentProps['handlePin'],
	): React.ReactElement {
		return (
			<ArticleNonBudgetaireComponent
				data={data}
				handlePin={handlePin}
				onChange={onChange}
				panel={this}
			/>
		);
	};
}

export default ArticleNonBudgetairePanel;
